import { motion } from "framer-motion";
import { Arch, Thread } from "@/components/Motifs";

const SanctumArches = ({ archC, archL, archR, archD }) => (
  <>
    <motion.div className="absolute left-[28%] -bottom-[14vh]" style={{ y: archC, z: -460, opacity: 0.45 }}>
      <Arch style={{ height: "150vh" }} stroke="var(--muted)" sw={1} />
    </motion.div>
    <motion.div className="absolute -left-[8vw] -bottom-[10vh]" style={{ y: archL, z: -330 }}>
      <div className="th-archlight" />
      <Arch style={{ height: "135vh" }} stroke="var(--sage-deep)" sw={1} />
    </motion.div>
    <motion.div className="absolute -right-[6vw] bottom-[4vh]" style={{ y: archR, z: -150 }}>
      <Arch style={{ height: "110vh" }} stroke="var(--ink-soft)" sw={1} />
    </motion.div>
    <motion.div className="absolute right-[24%] bottom-[10vh]" style={{ y: archD, z: -40, opacity: 0.55 }}>
      <Arch style={{ height: "92vh" }} stroke="var(--sage-deep)" sw={1} />
    </motion.div>
  </>
);

const SanctumVeils = ({ planeA, planeB, veilF }) => (
  <>
    <motion.div
      className="th-glass"
      style={{ y: planeA, z: -220, rotate: 8, left: "16%", top: "6%", width: "34vw", height: "52vh", background: "rgba(183,200,206,.16)" }}
    />
    <motion.div
      className="th-glass"
      style={{ y: planeB, z: -80, rotate: -7, right: "12%", top: "26%", width: "30vw", height: "46vh", background: "rgba(224,196,184,.14)" }}
    />
    <div className="th-beam" style={{ transform: "translateZ(-100px)", left: "22%" }} aria-hidden="true" />
    <div className="th-beam th-beam-blue" style={{ transform: "translateZ(-100px)", right: "18%", animationDelay: "-5s" }} aria-hidden="true" />
    <motion.div
      className="th-glass"
      style={{ y: veilF, z: 60, rotate: 3, left: "58%", top: "52%", width: "18vw", height: "30vh", background: "rgba(217,168,102,.1)" }}
    />
  </>
);

const SanctumTerrain = () => (
  <>
    <svg
      viewBox="0 0 1440 260"
      preserveAspectRatio="none"
      className="absolute bottom-0 left-0 w-full h-[30vh]"
      style={{ transform: "translateZ(40px)" }}
      aria-hidden="true"
    >
      <path d="M0 170 C 260 90, 480 210, 760 140 S 1240 80, 1440 170 V260 H0 Z" fill="var(--sage)" opacity=".22" />
      <path d="M0 210 C 300 150, 560 240, 880 190 S 1280 140, 1440 205 V260 H0 Z" fill="var(--blue)" opacity=".2" />
    </svg>
    <div className="absolute inset-0" style={{ transform: "translateZ(90px)" }}>
      <Thread d="M -20 300 C 260 180, 520 420, 1040 220" viewBox="0 0 1000 500" className="w-full h-full" flow stroke="var(--sage-deep)" sw={1} opacity={0.5} />
    </div>
    <div className="absolute inset-0" style={{ transform: "translateZ(90px)" }}>
      <Thread d="M -20 380 C 300 300, 640 480, 1040 330" viewBox="0 0 1000 500" className="w-full h-full" flow stroke="var(--amber)" sw={1} opacity={0.45} />
    </div>
    <div className="th-env-pulse" style={{ transform: "translateZ(-380px)" }} />
    <div
      className="th-env-pulse th-pulse-late"
      style={{ transform: "translateZ(-280px)", left: "56%", top: "46%", background: "radial-gradient(circle, rgba(170,185,163,.35), transparent 65%)" }}
    />
  </>
);

export const SanctumFallbackWorld = ({ camZ, rotX, rotY, archC, archL, archR, archD, planeA, planeB, veilF }) => (
  <div className="th-persp th-css-world">
    <motion.div className="th-world" style={{ z: camZ, rotateX: rotX, rotateY: rotY }}>
      <div className="th-ghostword" style={{ transform: "translateZ(-650px)", top: "10%", left: "6%", fontSize: "22vw", opacity: 0.045 }} aria-hidden="true">
        becoming
      </div>
      <div className="th-giant" style={{ transform: "translateZ(-520px)" }} aria-hidden="true">SANCTUM</div>
      <div className="th-fallback-aperture" aria-hidden="true" />
      <SanctumArches archC={archC} archL={archL} archR={archR} archD={archD} />
      <SanctumVeils planeA={planeA} planeB={planeB} veilF={veilF} />
      <SanctumTerrain />
    </motion.div>
  </div>
);